// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2-nZ7","left":"InfoRow_left__564XX"};